import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography,Box } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';

const ROOM_CLEANING_STATUS_HEADER = [
    {
        header: 'Nursing Station',
        accessor: 'nurseStation',
    },
    {
        header: 'Ward',
        accessor: 'ward',
    },
    {
        header: 'Room',
        accessor: 'room',
    },
    {
        header: 'Bed',
        accessor: 'bed_no',
    },
];


const initialOPDBillingDataObj = {
    data: [],
    loading: false
};

const initialRoomModeDataObj = {
    data: [],
    loading: false
};

export const RoomCleaningStatus = () => {
    const [detailList, setDetailList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentAction, setCurrentAction] = useState();
    const [selectedRecord, setSelectedRecord] = useState();
    const [ward, setWard] = useState([]);
    const [roomDataObj, setRoomDataObj] = useState(initialRoomModeDataObj)

    const methods = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                uhid: Yup.string().required(' '),
                patient_name: Yup.string().required(' '),
                opd_type: Yup.string().required(' '),
                ref_type: Yup.string().required(' '),
                doctor: Yup.string().required(' '),
                sponsor: Yup.string().required(' '),
                department: Yup.string().required(' '),
                bill: Yup.object().shape({
                    rec_amt_1: Yup.number().min(0, ' '),
                    rec_amt_2: Yup.number().min(0, ' '),
                    pay_mode: Yup.string().required(' ')
                })
            })
        ),
        defaultValues: {
            date: getCurrentDateTime('date'),
            time: getCurrentDateTime('time'),
            bill: {
                out_sourced: 'No',
                rec_amt_1: 0,
                rec_amt_2: 0,
                tds_amt: 0,
                disc_amt: 0,
                gst_amt: 0,
                net_amt: 0
            }
        },
        mode: 'all'
    });
    const { handleSubmit, watch, reset, setValue } = methods;
    const selectedWard = watch("ward_name");
    const getWardDropdown = useCallback(async () => {
        const data = await dropdownFetch('ward');
        setWard(data);
    }, []);

    useEffect(() => {
        fetchRoomData()
    }, [selectedWard])

    const fetchRoomData = async () => {
        setRoomDataObj({ loading: true });
        const response = await request('/room-master-list', { method: 'GET' });
        if (response.success) {
            const filteredData = response.data.filter((item) => item.ward?._id === selectedWard);
            setRoomDataObj({ loading: false, data: filteredData });
        } else {
            toast('Failed to load Room Chart', { variant: 'error' });
            setRoomDataObj({ loading: false });
        }
    };

    useEffect(() => {
        getWardDropdown();
    }, [getWardDropdown]);

    const formSubmit = async (formValues) => {
        setLoading(true);
        const payload = {
            bed_no: transformedData[0]?.bed_no,
            room_id: transformedData[0]?.room_id
        };

        let editFlag = false;
        if (selectedRecord && currentAction === 'edit') {
            editFlag = true;
        }

        const response = await request(editFlag ? '/' : '/room-master-cleaning-status-create', {
            method: editFlag ? 'PUT' : 'POST',
            params: editFlag ? selectedRecord._id : null,
            body: payload
        });

        if (response?.success) {
            toast(`Successfully ${editFlag ? 'edited' : 'created'}`, { variant: 'success' });
            setSelectedRecord(response.data);
            setCurrentAction();
            fetchRoomData();
        } else {
            toast(`Failed to ${editFlag ? 'edit' : 'create'}`, { variant: 'error' });
        }
        setLoading(false);
    };

    const prepareRoomData = (data) => {
        if (!data || data.length === 0) return [];
        return data.flatMap((room) =>
            room.beds
                .filter((bed) => bed.occupy_status === "R")
                .map((bed) => ({
                    nurseStation: room.nurse_station?.name || "N/A",
                    ward: room.ward?.name || "N/A",
                    room: room.room_no || "N/A",
                    bed_no: bed.bed_no || "N/A",
                    room_id: room._id
                }))
        );
    };


    const transformedData = prepareRoomData(roomDataObj.data);
    const handleRoomCleaned = (row) => {
        formSubmit()
    }

    return (
        <>
            <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
                <Container
                    sx={{
                        mt: 1,
                        border: '0px solid',
                        borderColor: 'grey.300',
                        borderRadius: 1,
                        width: '100%',
                        maxWidth: 'none',
                        minWidth: "100%",
                        boxSizing: 'border-box',
                    }}
                >
                    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
                        <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{
                                mb: 1,
                                borderBottom: '0px solid',
                                borderColor: 'grey.300'
                            }}
                        >
                            <Typography color="primary" variant="h3" fontWeight={700}>
                                Room Cleaning Status
                            </Typography>

                            <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                                <Button variant="contained">Exit</Button>
                            </Stack>
                        </Stack>
                        <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%',boxShadow: '0px 2px 10px #0099ff'  }}>
                        <Grid container spacing={2}>
                            <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Stack spacing={0.5} direction="row" alignItems="center">
                                    <Typography sx={{ flex: 0.2, fontSize: "1.6rem", fontWeight: 700 }}>Ward </Typography>
                                    <SelectTag formControlSX={{ flex: 0.8 }} name="ward_name" placeholder="Ward Name" menus={ward} />
                                </Stack>
                            </Grid>

                            <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Table
                                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '40rem' }}
                                    data={transformedData || []}
                                    columns={ROOM_CLEANING_STATUS_HEADER}
                                    size="small"
                                    roomCleaned={true}
                                    handleRoomCleaned={handleRoomCleaned}
                                />
                            </Grid>
                        </Grid>
                        </Box>
                    </FormProvider>
                </Container>
            </Paper >
        </>
    );
};
